import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuyPackageModalServices } from '../../../../../../../../selectors/buyPackageModal';
import { ServiceRow } from '../ServiceRow';

export const ServicesContainer = () => {
  const services = useSelector(selectBuyPackageModalServices);

  return (
    <>
      {services.map((service, key) => {
        return (
          <ServiceRow
            key={key}
            name={service.name}
            count={service.count}
            durationInDays={service.durationInDays}
            price={service.price}
            marketingPrice={service.marketingPrice}
          />
        );
      })}
    </>
  );
};
